import { SVGProps } from 'react';

const PauseIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5Z"
      fill="#E83F34"
    />
    <path
      d="M20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5Z"
      stroke="#CB2E1E"
    />
    <rect x="15" y="13" width="3" height="14" fill="white" />
    <rect x="22" y="13" width="3" height="14" fill="white" />
  </svg>
);

export default PauseIcon;
